import { KeyValue, KeyValueDefault } from '@/main/models/common';
import { InsurerFilterRequest } from '@/main/models/request/insurerRequest';
import { InsurerTypes, InsurerActionTypes } from './insurerTypes';

export function getInsurers(
  request: InsurerFilterRequest,
  keyReducer: string = 'default'
): InsurerActionTypes {
  return {
    type: InsurerTypes.GET_INSURERS,
    payload: {
      request,
      keyReducer
    }
  };
}

export function saveInsurers(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): InsurerActionTypes {
  return {
    type: InsurerTypes.SAVE_INSURERS,
    payload: { data, isError, errorMessages, keyReducer }
  };
}
export function getInsurersPublic(
  guidCountry: string,
  keyReducer: string = 'default'
): InsurerActionTypes {
  return {
    type: InsurerTypes.GET_INSURERS_PUBLIC,
    payload: {
      guidCountry,
      keyReducer
    }
  };
}

export function saveInsurersPublic(
  data: KeyValueDefault[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): InsurerActionTypes {
  return {
    type: InsurerTypes.SAVE_INSURERS_PUBLIC,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerInsurers(): InsurerActionTypes {
  return {
    type: InsurerTypes.RESET_REDUCER_INSURERS
  };
}

export function getInsurersFull(
  request: InsurerFilterRequest
): InsurerActionTypes {
  return {
    type: InsurerTypes.GET_INSURERS_FULL,
    payload: { request }
  };
}

export function saveInsurersFull(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): InsurerActionTypes {
  return {
    type: InsurerTypes.SAVE_INSURERS_FULL,
    payload: { data, isError, errorMessages }
  };
}

export function getUsersByInsurer(
  request: InsurerFilterRequest
): InsurerActionTypes {
  return {
    type: InsurerTypes.GET_INSURERS_USERS_BY_INSURER,
    payload: {
      request: {
        ...request,
        guidInsurer: request.guidInsurer ?? null
      }
    }
  };
}

export function saveUsersByInsurer(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): InsurerActionTypes {
  return {
    type: InsurerTypes.SAVE_INSURERS_USERS_BY_INSURER,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerInsurersFull(): InsurerActionTypes {
  return {
    type: InsurerTypes.RESET_REDUCER_INSURERS_FULL
  };
}
